import React from "react";

function CloudIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"></path>
    </svg>
  );
}

export default CloudIcon;
